import { IDbEntity } from './IDbEntity';

export interface IMetaDataRule extends IDbEntity {
	required: boolean;
	editable: boolean;
	defaultValue: string;
	validation?: IValidationRule[];
	item: IMetaDataItem;
}

export enum MetaDataValidators {
	REQUIRED = 'required',
	MIN_CHAR = 'minChar',
	MAX_CHAR = 'maxChar',
	EMAIL = 'email',
	PASSWORD = 'password',
	NUMBER = 'number',
	NUMERIC_ONLY = 'numericOnly',
	REGEX = 'regex',
}

export interface IValidationRule {
	type: MetaDataValidators;
	params?: { [key: string]: string | number | boolean | Date };
}

export interface MetaDataForm {
	[key: string]: string | number | Date | ServiceItem[];
}

export interface IMetaDataItem {
	code: string;
	name: string;
	key: keyof MetaData;
	description?: string;
	dataType: MetaDataType;
	filterEnabled: boolean;
	allowedValues?: Array<{ key: string; value: string }>;
	createdAt?: Date;
	updatedAt?: Date;
}

export interface ServiceItem {
	msisdn?: string;
	offerId?: number;
	companyId?: string;
	offerType?: string;
	printDate?: string;
	companyName?: string;
	offerPurpose?: string;
	shopNameCode?: string;
}

export interface MetaData {
	jmbg?: string;
	mb?: string;
	msisdn?: string;
	boxId?: string;
	iccid?: string;
	documentType?: string;
	documentCategory?: string;
	signDate?: Date;
	documentNumber?: string;
	archiveType?: string;
	isElectronicallySigned?: number;
	services?: ServiceItem[];
	calculationNumber?: number;
	identityNumber?: string;
	email?: string;
}

export enum MetaDataType {
	TEXT = 'string',
	NUMBER = 'integer',
	BOOL = 'boolean',
	DATE = 'datetime',
	SELECT = 'select',
	JSON = 'json',
}
